var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.validateBeforeSubmit.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        {
          class: ["form-group", { "is-invalid": _vm.$v.loginData.user.$error }]
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.loginData.user,
                expression: "loginData.user",
                modifiers: { trim: true }
              }
            ],
            staticClass: "form-control",
            class: { "is-invalid": _vm.$v.loginData.user.$error },
            attrs: { placeholder: "Ingrese usuario", type: "text" },
            domProps: { value: _vm.loginData.user },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.loginData, "user", $event.target.value.trim())
                },
                function($event) {
                  return _vm.$v.loginData.user.$touch()
                }
              ],
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          !_vm.$v.loginData.user.required
            ? _c("span", { staticClass: "invalid-feedback" }, [
                _vm._v("\n      El usuario es requerido\n    ")
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "form-group",
            { "is-invalid": _vm.$v.loginData.password.$error }
          ]
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.loginData.password,
                expression: "loginData.password",
                modifiers: { trim: true }
              }
            ],
            staticClass: "form-control",
            class: { "is-invalid": _vm.$v.loginData.password.$error },
            attrs: { placeholder: "Ingrese contraseña", type: "password" },
            domProps: { value: _vm.loginData.password },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.loginData,
                    "password",
                    $event.target.value.trim()
                  )
                },
                function($event) {
                  return _vm.$v.loginData.password.$touch()
                }
              ],
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          !_vm.$v.loginData.password.required
            ? _c("span", { staticClass: "invalid-feedback" }, [
                _vm._v("\n      La contraseña es requerida\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$v.loginData.password.minLength
            ? _c("span", { staticClass: "invalid-feedback" }, [
                _vm._v(
                  "\n      La contraseña debe tener al menos " +
                    _vm._s(_vm.$v.loginData.password.$params.minLength.min) +
                    " letras.\n    "
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary ladda-button btn-full",
          attrs: {
            slot: "button",
            type: "button",
            "data-style": "expand-right"
          },
          on: { click: _vm.validateBeforeSubmit },
          slot: "button"
        },
        [_vm._v("Ingresar")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46ec553e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46ec553e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/auth/Login.vue
// module id = 582
// module chunks = 0